import { render, staticRenderFns } from "./MerchantOrders.vue?vue&type=template&id=b58db90e&scoped=true"
import script from "./MerchantOrders.vue?vue&type=script&lang=js"
export * from "./MerchantOrders.vue?vue&type=script&lang=js"
import style0 from "./MerchantOrders.vue?vue&type=style&index=0&id=b58db90e&prod&scoped=true&lang=css"
import style1 from "./MerchantOrders.vue?vue&type=style&index=1&id=b58db90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58db90e",
  null
  
)

export default component.exports